module.exports = __webpack_public_path__ + "img/icon20.4e538c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon20.png
// module id = BxYi
// module chunks = 2